module.exports = __webpack_public_path__ + "static/media/front.7e7d3290.svg";